import LogoS from '../../assets/images/n-logo-c.png'
import PHP from '../../assets/images/php_project.PNG'
import jsp from '../../assets/images/EmployeeList.PNG'
import projectManagement from '../../assets/images/supervisorStatusStudent.PNG'
import zone from '../../assets/images/Zone.jpg'
import mark from '../../assets/images/TeamMark.jpeg'
export const dataProjects = [
  {
    id: 1,
    title: 'Prroperty Management System',
    techs: 'HTML, CSS, JavaScript, PHP & MSSQL',
    link: PHP,
    description: 'Contributed to the project by developing user management.',
  },
  {
    id: 2,
    title: 'Apparel Management System',
    techs: 'HTML, CSS, Bootstrap, Java , Jsp servlet & MSSQL',
    link: jsp,
    description:
      'Contributed to the project by developing employee management,attendandance & leave management',
  },
  {
    id: 3,
    title: 'Project Management System',
    techs: 'HTML, CSS, ReactJS, NodeJS & MongoDB',
    link: projectManagement,
    description:
      'Contributed to the project by developing Request supervisor function.',
  },
  {
    id: 4,
    title: 'Hospital Management System',
    techs: 'HTML, CSS, ReactJS, NodeJS & MongoDB',
    link: zone,
    description:
      'Contributed to the project by developing Medical Program  and payment management.',
  },
  {
    id: 1,
    title: 'Rent a Car Android Mobile App',
    techs: 'Java',
    link: mark,
    description:
      'Contributed to the project by developing User registration & create advertisement function',
  },
]
